import React, {
	useEffect, useState
}from "react"
import {
	Form,
	DatePicker,
    Row,
    Col,
	Checkbox,
	Modal,
	Popconfirm,
	Tooltip,
	Spin,
	Select
}from "antd"
import {
	useDebounce
}from "use-lodash-debounce"
import { useSelector, useDispatch } from "react-redux"
import i18n from "./localization"
import {
	CustomSelect
}from '../../../components/CustomSelect'
import {
	CustomInput
}from "../../../components/CustomInput"
import CustomButton from '../../../components/ButtonCustom'
import Line from '../../../../public/line.svg'
import Plus from '../../../../public/Glyph_ .svg'
import "./style.css"
import ReportParameter from "./reportParametr";
import { tableReportsActions } from "../../Management/TableReports/actions"
import moment from "moment"
import Notifications from "../../../helpers/Notifications"
import history from "../../../helpers/history";
const { RangePicker } = DatePicker

const TableReportForm = ({
    editMode = false, createMode=false, mainMode=false
}) => {
	const dispatch = useDispatch()
	const [form] = Form.useForm()
	const [searchOrg, setSearchOrg] = useState('')
	const searchOrgValue = useDebounce(searchOrg, 500)
	const {
		reOrgsList, 
		reOrgsListLoading, 
		deleteReOrgReportSettingResult,
		createReOrgReportSettingResult,
		CUDReOrgReportSettingLoading,
		updateReOrgReportSettingResult,
	} = useSelector((state) => state.tableReportReducer)
	const settingsEnum = useSelector((state) => state.tableReportReducer.settingsListForReportGenerator)
	const currentSettings = useSelector((state) => state.tableReportReducer.currentReOrgReportSetting)
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const [rows, setRows] = useState([{paramId: null, valueIds: []}])
	const [cols, setCols] = useState([{paramId: null, valueIds: []}])
	const [id, setId] = useState(null)
	const [isRequired, setIsRequired] = useState(true)
	const [filtredSettingsEnum, setFiltredSettingsEnum] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [unlockBtn, setUnlockBtn] = useState(false)
	const maxNameLength = 60

	useEffect(() => {
		if(!settingsEnum){
			dispatch(tableReportsActions.getSettingsListForReportGenerator())
		}
		return () => {
			dispatch(tableReportsActions.clearReOrgsListForReportGenerator())
			dispatch(tableReportsActions.clearCurrentReOrgReportSetting())
			dispatch(tableReportsActions.clearAllReOrgReportSettingsList())
		}
	},[])

	useEffect(() => {
		if(!filtredSettingsEnum && settingsEnum)
			setFiltredSettingsEnum(settingsEnum)
	}, [settingsEnum])

	useEffect(() => {
		if(currentSettings && (!createMode || (createMode && !editMode))){
			form.resetFields()
			setRows(currentSettings.rows)
			setCols(currentSettings.columns)
			setId(currentSettings.id)
			form.setFieldsValue({
				lastYearPercentage: currentSettings.lastYearPercentage,
				isUnderControl: currentSettings.isUnderControl,
				name: currentSettings.name,
				nameBel: currentSettings.nameBel,
			})
			cols.map((col, index) => {
				form.setFieldsValue({
					[`${id}colSelect${index+1}`]: col.paramId,
					[`${id}colValueSelect${index+1}`]: col.valueIds,
				  });
			})
			rows.map((row, index) => {
				form.setFieldsValue({
					[`${id}rowSelect${index+1}`]: row.paramId,
					[`${id}rowValueSelect${index+1}`]: row.valueIds,
				  });
			})
		}
	},[currentSettings])

	useEffect(() => {
		if (searchOrgValue?.length > 2){
			dispatch(tableReportsActions.getReOrgsListForReportGenerator({
				Search     : searchOrgValue,
			}))
		}
	}, [searchOrgValue])

	useEffect(() => {
		if(deleteReOrgReportSettingResult){
			dispatch(tableReportsActions.getAllReOrgReportSettingsList())
			Notifications.successNotice(i18n.templateRemoveSuccess[isRu], null, 5)
			dispatch(tableReportsActions.clearCRUDResultForReportGenerator())
			history.push("/tableReports")
		} else if(deleteReOrgReportSettingResult === false){
			Notifications.infoNotice(i18n.noChangesSet[isRu], null, 5)
			dispatch(tableReportsActions.clearCRUDResultForReportGenerator())
		}
	}, [deleteReOrgReportSettingResult])

	useEffect(() => {
		if(createReOrgReportSettingResult){
			Notifications.successNotice(i18n.templateAddSuccess[isRu], null, 5)
			dispatch(tableReportsActions.clearCRUDResultForReportGenerator())
		} else if(createReOrgReportSettingResult === false){
			Notifications.infoNotice(i18n.noChangesSet[isRu], null, 5)
			dispatch(tableReportsActions.clearCRUDResultForReportGenerator())
		}
	},[createReOrgReportSettingResult])

	useEffect(() => {
		if(updateReOrgReportSettingResult){
			Notifications.successNotice(i18n.templateUpdateSuccess[isRu], null, 5)
			dispatch(tableReportsActions.clearCRUDResultForReportGenerator())
			if(id){
				dispatch(tableReportsActions.getCurrentReOrgReportSetting({settingId:id}))
			}
			history.push("/tableReports")
		} else if(updateReOrgReportSettingResult === false){
			Notifications.infoNotice(i18n.noChangesSet[isRu], null, 5)
			dispatch(tableReportsActions.clearCRUDResultForReportGenerator())
		}
	},[updateReOrgReportSettingResult])

	useEffect(()=>{
		const chosenParamIds = [...rows, ...cols].map(value => {
			return value.paramId
		})
		setUnlockBtn(rows?.length > 0 && cols?.length > 0)
		setFiltredSettingsEnum(settingsEnum?.map(value => {
			value.disabled = chosenParamIds.includes(value.id) 
			return value
		}))
	},[rows, cols])

	const handleReportGenerate = (value) => {
		dispatch(tableReportsActions.generateTableReport(
			{
				startDate: value.date[0].format("YYYY-MM-DD"),
				endDate: value.date[1].format("YYYY-MM-DD"),
				reOrgId: value.reOrgId,
				lastYearPercentage: value.lastYearPercentage,
				isUnderControl: value.isUnderControl,
				rows: Object.values(rows),
				columns: Object.values(cols)
			}, 
			{ 
				fileName: i18n.reportFromTo[isRu].format(moment(value.date[0]).format("DD.MM.YYYY"), moment(value.date[1]).format("DD.MM.YYYY")),
				fileExtension: ".xlsx"
			}
		))
	}

	const handleSaveReportPattern = (value) => {
		dispatch(tableReportsActions.createReOrgReportSetting({
			name: value.name,
			nameBel: value.nameBel,
			lastYearPercentage: form.getFieldValue("lastYearPercentage"),
			isUnderControl: form.getFieldValue("isUnderControl"),
			rows: Object.values(rows),
			columns: Object.values(cols)
		}))
		setShowModal(false)
	}

	const handleSaveNewReport = async () => {
		setIsRequired(false) 
		try {
			await form.validateFields() 
			setShowModal(true)
		} catch (err) {

		} finally{
			setIsRequired(true)
		}
	}

	const handleEditReportPattern = (value) => {
		dispatch(tableReportsActions.updateReOrgReportSetting({
			id: id,
			name: value.name,
			nameBel: value.nameBel,
			lastYearPercentage: value.lastYearPercentage,
			isUnderControl: value.isUnderControl,
			rows: Object.values(rows),
			columns: Object.values(cols)
		}))
	}

    const handleRemoveReportPattern = () =>{
		dispatch(tableReportsActions.deleteReOrgReportSetting({id: id}))
	 }

    const handleColumnAdd = () => {
		if(rows.length + cols.length < settingsEnum.length)
        setCols(value => [...value, {paramId: null, valueIds: []}])
    }

    const handleRowAdd = () => {
		if(rows.length + cols.length < settingsEnum.length)
		setRows(value => [...value, {paramId: null, valueIds: []}])
    }

	const handleRowDelete = (key) => {
		rows.map((_, index) => {
			if(index >= key){
				form.setFieldsValue({
					[`${id}rowSelect${index+1}`]: index+2 <= rows.length ? form.getFieldValue(`${id}rowSelect${ index+2 }`) : null,
					[`${id}rowValueSelect${index+1}`]: index+2 <= rows.length ? form.getFieldValue(`${id}rowValueSelect${ index+2 }`) : [],
				})
			}
		})
		const updatedRows = rows.filter((_, index) => index !== key);
		setRows(updatedRows);
	};

	const handleColumnDelete = (key) => {
		cols.map((_, index) => {
			if(index >= key){
				form.setFieldsValue({
					[`${id}colSelect${index+1}`]: index+2 <= cols.length ? form.getFieldValue(`${id}colSelect${ index+2 }`) : null,
					[`${id}colValueSelect${index+1}`]: index+2 <= cols.length ? form.getFieldValue(`${id}colValueSelect${ index+2 }`) : [],
				})
			}
		})
		const updatedCols = cols.filter((_, index) => index !== key);
		setCols(updatedCols);
	};

	const handleRowChange = (key, newValue) => {
		const updatedRows = rows.map((row, index) =>
		  index === key
			? { paramId: newValue.paramId, valueIds: newValue.valueIds }
			: row
		);
		setRows(updatedRows);
		form.setFieldsValue({
			[`${id}rowSelect${key+1}`]:newValue.paramId,
			[`${id}rowValueSelect${key+1}`]:newValue.valueIds
		})
	  };

	  const handleColumnChange = (key, newValue) => {
		const updatedCols = cols.map((col, index) =>
		  index === key
			? { paramId: newValue.paramId, valueIds: newValue.valueIds }
			: col
		);
		setCols(updatedCols);
		form.setFieldsValue({
		  [`${id}colSelect${key+1}`]: newValue.paramId,
		  [`${id}colValueSelect${key+1}`]: newValue.valueIds,
		});
	  };

	const CustomButtonWithLabel = ({ label, isVisible = true, popconfirm = false, btnName, ...props }) => {
		return (isVisible &&
				<Form.Item
					name={btnName}
					className="customBtnWithLabel"
				>
					 {
						popconfirm 
						? <Popconfirm {...popconfirm}>
							<CustomButton   {...props}>
								{label}
							</CustomButton>
						</Popconfirm>
						: <CustomButton {...props}>
							{label}
						</CustomButton>
					 }
					
				</Form.Item>
		);
	}

	const getBtnsProps = [
		{
			label: 	createMode 
					  ? i18n.saveAsNewTemplate[isRu]
					  : i18n.removeTemplate[isRu],
			isVisible:  editMode && (!createMode || unlockBtn),
			disabled: !unlockBtn && createMode,
			type:	"turquoise",
			onClick: createMode 
					 ? handleSaveNewReport
					 : null,
			btnName: "saveAsNewOrRemoveBtn",
			popconfirm: createMode 
						? false
						: {
							cancelText: i18n.no[isRu],
							okText: i18n.yes[isRu],
							title: i18n.sureWantToDeleteTemplate[isRu],
							onCancel: () => { return null},
							onConfirm: () => handleRemoveReportPattern()
						}
		},
		{
			label: 	editMode 
					? createMode 
						? i18n.downloadReport[isRu] 
						: i18n.saveTemplate[isRu]  
					: i18n.downloadReport[isRu],
			isVisible:  !mainMode,
			disabled: !unlockBtn,
			type:	"orange",
			htmlType: "submit",
			btnName: "downloadOrSaveBtn",
		}
	]


	return (
		<Form
			id="mainTableReportForm"
			form={ form }
			className="mainTableReportForm"
			onFinish={ editMode 
					   ? createMode 
						 ? handleReportGenerate 
						 : handleEditReportPattern 
					   : handleReportGenerate}
		>
			<Modal
				destroyOnClose
				footer={ null }
				title={ i18n.enterTemplateName[isRu] }
				width={800}
				height={400}
				visible={ showModal }
				onCancel={ () => setShowModal(false) }
			>
				<Form 
					name="modalForm"
					onFinish={handleSaveReportPattern}
				>
					<Row className="modalFormFieldRow">
						<Form.Item 
							name="name"
							rules ={[
										{
											required: true,
											message: i18n.emptyNameFieldMessage[isRu],
											whitespace: true
										},
										{
											max:maxNameLength,
											message: i18n.maxAllowedLength[isRu].format(maxNameLength)
										}
									]} 
							label={i18n.nameFieldPlaceholder[isRu]}
							className="modalFormField"
						>
							<CustomInput placeholder={i18n.nameFieldPlaceholder[isRu]}/>
						</Form.Item> 
					</Row>
					<Row className="modalFormFieldRow">
						<Form.Item 
							name="nameBel"
							rules ={[
								{
									max:maxNameLength,
									message: i18n.maxAllowedLength[isRu].format(maxNameLength)
								}
							]} 
							label={i18n.nameBelFieldPlaceholder[isRu]}
							className="modalFormField"
						>
							<CustomInput placeholder={i18n.nameBelFieldPlaceholder[isRu]}/>
						</Form.Item> 
					</Row>
					<Row className="saveTemplateBtnRow">
						<Form.Item 
							name="saveTemplateBtn"
						>
							<CustomButton
								loading={ CUDReOrgReportSettingLoading }
								type="orange"
								htmlType="submit"
							>
								{ i18n.saveTemplate[isRu] }
							</CustomButton>
						</Form.Item>
					</Row>
				</Form>
			</Modal>
			{ 
				editMode && !createMode &&
				<Row gutter={16}>
					<Col span={12}>
						<Tooltip title = {i18n.nameFieldPlaceholder[isRu]}>
							<Form.Item 
								name="name"
								rules ={[
											{
												required: true,
												message: i18n.emptyNameFieldMessage[isRu],
												whitespace: true
											},
											{
												max:maxNameLength,
												message: i18n.maxAllowedLength[isRu].format(maxNameLength)
											}
										]} 
							>
								<CustomInput placeholder={i18n.nameFieldPlaceholder[isRu]}/>
							</Form.Item>
						</Tooltip> 
					</Col>
					<Col span={12}>
						<Tooltip title = {i18n.nameBelFieldPlaceholder[isRu]}>
							<Form.Item 
								name="nameBel"
								rules ={[
									{
										max:maxNameLength,
										message: i18n.maxAllowedLength[isRu].format(maxNameLength)
									}
								]} 
							>
								<CustomInput placeholder={i18n.nameBelFieldPlaceholder[isRu]}/>
							</Form.Item> 
						</Tooltip>
					</Col>
				</Row>
			}
			{
				createMode &&
				<Row gutter={16}>
                <Col span={12}>
                    <Form.Item 
                        name="date"
                        rules ={[
                                	{
                                    	type: 'array',
                                        required: isRequired,
										message: i18n.emptyDateFieldMessage[isRu]
                                    }
                                ]}
					>
                        <RangePicker
                            allowClear
                            allowEmpty={ [false, false] }
                            format="DD.MM.YYYY"
                            separator={ <img src={ Line } style={{verticalAlign: "middle"}} /> }
                        />
                    </Form.Item> 
                </Col>
                <Col span={12}>
					<Form.Item
						name="reOrgId"
						rules={[{
							required	: isRequired,
							message		: i18n.emptyReOrgFieldMessage[isRu]
						}]}
					>
						<CustomSelect
							allowClear
							showSearch
							filterOption={ false }
							placeholder={ i18n.reOrgPlaceholder[isRu] }
							onSearch={ (value) => setSearchOrg(value) }
						>
							{reOrgsListLoading ? (
								<Select.Option disabled>
									<Spin />
								</Select.Option>
							) : (
								reOrgsList?.map((org, index) => (
									<Select.Option key={index} value={org.id} className='optionWithFullTitle'>
										<span>
											{isRu || !org.fullNameBel ? org.fullName : org.fullNameBel}
										</span>
									</Select.Option>
								))
							)}
						</CustomSelect>
					</Form.Item>
                </Col>
				</Row>
			}
			{	unlockBtn &&
				<Row className="lastYearPercentage">
					<Form.Item
						name="lastYearPercentage"
						valuePropName="checked"
						noStyle
					>
						<Checkbox disabled = {!editMode}>
							{i18n.compareToPreviousYear[isRu]}
						</Checkbox>
					</Form.Item>
					<Form.Item
						name="isUnderControl"
						valuePropName="checked"
						noStyle
					>
						<Checkbox disabled = {!editMode}>
							{i18n.isUnderControl[isRu]}
						</Checkbox>
					</Form.Item>
				</Row>
			}
			
			{	
				editMode &&
                <Form.Item
					name="addNewColumn"
				>
					<CustomButton
						type="orange"
						className="customBtnWithPlus"
                        onClick = {handleColumnAdd}
					>
						    <img
								alt={ i18n.addNewColumn[isRu] }
								src={ Plus }
							/>
							<span>
								{ i18n.addNewColumn[isRu] }
							</span>
					</CustomButton>
				</Form.Item>
            }
 			{
				cols?.map((col, index) => {
					return (
						<ReportParameter 
							isRu={isRu}
							key = {`${id}col${index}`}
							number = {index+1}
							reportId = {id}
							settingsEnum={filtredSettingsEnum}
							isColumn={true}
							parameter={col}
							disabled={!editMode}
							onParameterChange={(value) => handleColumnChange( index, value)}
							onParameterDelete={() => handleColumnDelete(index)}
						/>)
				})
			} 
			{	
				editMode &&
                <Form.Item
					name="addNewRow"
				>
					<CustomButton
						type="turquoise"
						className="customBtnWithPlus"
                        onClick = {handleRowAdd}
					>
						    <img
								alt={ i18n.addNewRow[isRu] }
								src={ Plus }
							/>
							<span>
								{ i18n.addNewRow[isRu] }
							</span>
					</CustomButton>
				</Form.Item>
			}
			{
				rows?.map((row, index) => {
					return (
						<ReportParameter 
							isRu={isRu}
							settingsEnum={filtredSettingsEnum}
							key = {`${id}row${index}`}
							number = {index+1}
							reportId = {id}
							isColumn={false}
							parameter={row}
							disabled={!editMode}
							onParameterChange={(value) => handleRowChange(index, value)}
							onParameterDelete={() => handleRowDelete(index)}
						/>)
				})
			} 
					<Row className="customBtnWithLabelRow">
						<CustomButtonWithLabel {...getBtnsProps[0]}/>
						<CustomButtonWithLabel {...getBtnsProps[1]}/>
					</Row>
						
		</Form>
	)
}

export default TableReportForm
